<template>
  <div>
    <LoadingSpinner :loading="isLoading" :text="$lang.sending_data" />
    <EnumForm
      v-show="!isLoading"
      :permissions="permissions"
      @close="close"
      @submit="submit"
    />
  </div>
</template>

<script>
import LoadingSpinner from "@/components/base/LoadingSpinner";
import EnumForm from "../forms/enumForm.vue";
import { mapActions } from "vuex";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "edit-enum",
  components: { LoadingSpinner, EnumForm },

  props: {
    itemId: {
      type: Number,
      default: null,
    },
    permissions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    ...mapActions(["getAllEnumeration"]),
    generateApiUrl,
    close() {
      this.$emit("close");
    },
    async submit(payload) {
      try {
        delete payload.is_enable;
        this.isLoading = true;
        const url = generateApiUrl(["profile", "enum"]);
        const response = await this.$httpService.post(url, payload);
        this.$notify.success(response.data.message);
        this.$emit("getData");
        this.close();
        this.getAllEnumeration();
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>
